import { render } from "./ListEditor.vue?vue&type=template&id=6015a18f"
import script from "./ListEditor.vue?vue&type=script&lang=js"
export * from "./ListEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__